import * as FeatureHubReact from '@feature-hub/react';
import * as ModuleLoaderAmd from '@feature-hub/module-loader-amd';
import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as UnifiedWebCommonAlpha from '@oneaudi/unified-web-alpha-common';
import * as oneGraphClient from '@oneaudi/onegraph-client';
import * as oneGraphQueryService from '@oneaudi/onegraph-query-service';
import * as oneGraphService from '@oneaudi/onegraph-service';
import * as styled from 'styled-components';

const definedExternals: ModuleLoaderAmd.Externals = {
  '@feature-hub/module-loader-amd': ModuleLoaderAmd,
  '@feature-hub/react': FeatureHubReact,
  '@oneaudi/onegraph-client': oneGraphClient,
  '@oneaudi/onegraph-query-service': oneGraphQueryService,
  '@oneaudi/onegraph-service': oneGraphService,
  '@oneaudi/unified-web-alpha-common': UnifiedWebCommonAlpha,
  '@volkswagen-onehub/onegraph-client': oneGraphClient,
  react: React,
  'react-dom': ReactDom,
  'styled-components': styled,
};

const providedExternals = {
  '@feature-hub/module-loader-amd': process.env.FEATURE_HUB_VERSION as string,
  '@feature-hub/react': process.env.FEATURE_HUB_VERSION as string,
  '@oneaudi/onegraph-client': process.env.ONEGRAPH_CLIENT_VERSION as string,
  '@oneaudi/onegraph-query-service':
    process.env.SERVICE_ONEGRAPH_QUERY_SERVICE_VERSION,
  '@oneaudi/onegraph-service': process.env.SERVICE_ONEGRAPH_SERVICE_VERSION,
  '@oneaudi/unified-web-alpha-common': process.env
    .UNIFIED_WEB_ALPHA_COMMON_VERSION as string,
  '@volkswagen-onehub/onegraph-client': process.env
    .ONEGRAPH_CLIENT_VERSION as string,
  react: process.env.REACT_VERSION as string,
  'react-dom': process.env.REACT_DOM_VERSION as string,
  'styled-components': process.env.STYLED_COMPONENTS_VERSION as string,
};

export { definedExternals, providedExternals };
